import axios from "axios";
import { store } from "@/store";
import NProgress from "nprogress";
 
export default() => {
	const instance = axios.create({
		baseURL: `${process.env.VUE_APP_PRO_URL}/api/v2`,
		params: {
			token: store.state.token
		},
		headers: {
			"Accept": "application/json",
			"Content-Type": "application/json"
		}
	});

	// before a request is made start the nprogress
	instance.interceptors.request.use(config => {
		NProgress.start();
		return config;
	});

	// before a response is returned stop nprogress
	instance.interceptors.response.use(response => {
		NProgress.done();
		return response;
	});

	return instance;
};
